import { render } from "./ListCenter.vue?vue&type=template&id=658b6bb2&scoped=true"
import script from "./ListCenter.vue?vue&type=script&lang=js"
export * from "./ListCenter.vue?vue&type=script&lang=js"

import "./ListCenter.vue?vue&type=style&index=0&id=658b6bb2&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658b6bb2"]])

export default __exports__